import { InjectionToken } from "@angular/core";
import { CashFlowPort } from "./cash-flow.port";

export const CASH_FLOW_PORT = new InjectionToken<CashFlowPort>("CASH_FLOW_PORT");
